import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { FormProvider } from 'react-hook-form';
import PropTypes from 'prop-types';
import { KEYCODE } from 'constants/IncorporationConstants';
import * as alertActions from 'redux/ducks/common/alertDucks';

const Form = ({ formControl, handleSubmit, children }, ref) => {
  const submitButton = useRef(null);
  const dispatch = useDispatch();
  const formClear = () => {
    formControl.reset();
    formControl.clearErrors();
  };

  useImperativeHandle(ref, () => ({
    submit: () => {
      submitButton.current.click();
    },
    clear: () => {
      formClear();
    },
  }));

  const onError = (errors, e) => {
    const firstErrorName = Object.keys(errors).reduce((field, a) => {
      return errors[field] ? field : a;
    }, null);
    if (firstErrorName) {
      dispatch(
        alertActions.open({
          isDimed: true,
          message: [errors[firstErrorName]?.message],
        }),
      );
    }
  };

  // form 내 input enter key submit 방지
  const handleKeyUp = e => {
    if (e.code === KEYCODE.ENTER || e.code === KEYCODE.NUMPADENTER) {
      e.preventDefault();
    }
  };

  return (
    <FormProvider {...formControl}>
      <form onSubmit={formControl.handleSubmit(handleSubmit, onError)} onKeyDown={e => handleKeyUp(e)}>
        {children}
        <button hidden ref={submitButton} type="submit">
          save but hidden :)
        </button>
      </form>
    </FormProvider>
  );
};

Form.propTypes = {
  children: PropTypes.node.isRequired,
  formControl: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default forwardRef(Form);
